import React from "react";
import { Link } from "react-router-dom";

const MultilingualPlatform = () => {
  const features = [
    { text: "UK-Based", icon: "🇬🇧" },
    { text: "Registered Professionals", icon: "🛡️" },
    { text: "Multilingual Niche", icon: "🌍" },
    { text: "Cultural Sensitivity", icon: "💎" },
    { text: "Clinically Supervised", icon: "🎓" },
    { text: "Safeguarding Trained", icon: "✅" },
  ];

  const seoKeywords = [
    "Arabic speaking therapist UK",
    "Kurdish speaking therapist UK",
    "Spanish therapist London",
    "Online therapy in different languages",
    "Multilingual therapy UK",
    "Therapy in your native language"
  ];

  return (
    <section id="native-language" className="py-24 bg-white font-poppins relative overflow-hidden scroll-mt-[86px]">
      {/* Subtle background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-[0.03] pointer-events-none">
        <div className="absolute top-[-10%] left-[-5%] w-[40%] h-[40%] bg-primary rounded-full blur-[120px]"></div>
        <div className="absolute bottom-[-10%] right-[-5%] w-[40%] h-[40%] bg-tertiary rounded-full blur-[120px]"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">

        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-light text-text leading-tight mb-6">
            Therapy in your <span className="text-primary italic font-medium">native language</span>
          </h2>
          <div className="flex items-center justify-center gap-4">
            <div className="h-[1px] w-12 bg-tertiary"></div>
            <p className="text-primary uppercase tracking-[0.3em] text-xs font-bold">
              Global Support • Local Connection
            </p>
            <div className="h-[1px] w-12 bg-tertiary"></div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left Side */}
          <div className="space-y-10">
            <div className="relative">
              <div className="absolute -left-4 top-0 w-1.5 h-full bg-gradient-to-b from-primary to-tertiary rounded-full"></div>
              <p className="text-xl md:text-2xl text-text/80 leading-relaxed font-light pl-6">
                Mind Therapy Counselling is a <span className="font-semibold text-text">UK-based multilingual</span> therapy platform.
                We connect you with professionally registered therapists across <span className="text-primary font-medium">London and the UK</span>,
                ensuring ethical and culturally sensitive support.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-y-8 gap-x-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-4 group">
                  <span className="text-3xl transition-all duration-300 transform group-hover:scale-110">
                    {feature.icon}
                  </span>
                  <span className="text-[15px] font-semibold text-text/80 group-hover:text-primary transition-colors">
                    {feature.text}
                  </span>
                </div>
              ))}
            </div>

            <div className="pt-6 border-t border-gray-50">
              <p className="text-gray-400 italic text-lg font-light">
                "Therapy in your native language in the UK"
              </p>
            </div>
          </div>

          {/* Right Side */}
          <div className="space-y-8">
            <div className="bg-[#F8F9FA] p-10 rounded-[40px] border border-primary/5 shadow-sm hover:shadow-md hover:border-primary/20 transition-all duration-500">
              <h3 className="text-lg font-bold text-primary mb-6 flex items-center gap-3">
                <span className="w-2 h-2 rounded-full bg-tertiary animate-pulse"></span>
                Specialized Services
              </h3>
              <div className="flex flex-wrap gap-2 text-primary font-medium">
                {seoKeywords.map((keyword, idx) => (
                  <span
                    key={idx}
                    className="px-4 py-2 bg-white rounded-full text-[13px] border border-gray-100 hover:border-tertiary hover:bg-tertiary/10 transition-all cursor-default shadow-sm text-center"
                  >
                    {keyword}
                  </span>
                ))}
              </div>
              <div className="mt-6 text-center">
                <span className="text-gray-400 text-sm font-medium italic">
                  ...and more
                </span>
              </div>
            </div>

            <div className="bg-tertiary p-10 rounded-[40px] text-text shadow-xl relative overflow-hidden group border border-primary/10 hover:border-primary/30 transition-all duration-500">
              <div className="relative z-10">
                <h3 className="text-2xl font-semibold mb-3 italic text-primary">For Therapists</h3>
                <p className="text-text/70 mb-8 font-light leading-relaxed text-lg">
                  No monthly fees. No upfront cost.<br/>
                  <span className="text-xl font-bold text-primary">Grow with us.</span>
                </p>
                <Link
                  to="/signUpTherapist"
                  className="inline-block px-10 py-4 bg-button-bg text-white font-bold rounded-full hover:bg-tertiary hover:text-primary transition-all duration-300 shadow-xl active:scale-95 text-center min-w-[200px]"
                >
                  Join Our Network
                </Link>
              </div>
              <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-primary/10 rounded-full blur-2xl group-hover:scale-125 transition-transform duration-700"></div>
              <div className="absolute top-[-20%] left-[-10%] w-32 h-32 bg-primary/5 rounded-full blur-xl animate-pulse"></div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default MultilingualPlatform;
